import * as XLSX from "xlsx";
import {saveAs} from "file-saver";

export const ExcelFileGeneratorUtil = ({
                                           filename = `output.xlsx`,
                                           formattedDataForExcelFile = [],
                                           worksheetName = "sheet 1"
                                       }) => {
    const worksheet = XLSX.utils.json_to_sheet(formattedDataForExcelFile, {
        origin: "A1",
    });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        worksheetName
    );
    const excelBuffer = XLSX.write(workbook, {bookType: "xlsx", type: "array"});
    const blob = new Blob([excelBuffer], {type: "application/octet-stream"});
    saveAs(blob, filename);
};
